import React from 'react';
import { Box, BoxProps } from '@mui/material';
import { SEARCE_COLORS } from '../../theme';

interface SectionTitleProps extends BoxProps {
  children: React.ReactNode;
}

const SectionTitle: React.FC<SectionTitleProps> = ({ children, sx, ...rest }) => (
  <Box
    component="span"
    sx={{
      display: 'inline-block',
      fontSize: '0.875rem',
      fontWeight: 700,
      color: SEARCE_COLORS.primary,
      pb: '8px',
      mb: '16px',
      borderBottom: `2.5px solid ${SEARCE_COLORS.primary}`,
      ...sx,
    }}
    {...rest}
  >
    {children}
  </Box>
);

export default SectionTitle;
